// removed by extract-text-webpack-plugin
module.exports = {"NavigationItem":"NavigationItem__NavigationItem__1kHp5","Link":"NavigationItem__Link__1iTib","Icon":"NavigationItem__Icon__M9tei","Line":"NavigationItem__Line__3JL45","active":"NavigationItem__active__j2tPx"};


//////////////////
// WEBPACK FOOTER
// ./client/src/components/Navigation/NavigationItems/NavigationItem/NavigationItem.css
// module id = 305
// module chunks = 0